import { API_BASE } from 'shared/constants/Api'

export const KEY_FIGURE_REPORT = `${API_BASE}/api/v2/financial-presenter/key_figures_reports/`
export const TAX_REPORT = `${API_BASE}/api/v2/financial-presenter/tax_payment_reports/`
export const FINANCIAL_REPORTS = `${API_BASE}/api/v2/financial-presenter/fiscal_reports/`
export const ANNUAL_REPORTS = `${API_BASE}/api/v2/financial-presenter/annual_reports/`
